<template>
  <page-markup
    class="body-bg-color membership-template-builder w-full h-full"
    :style="[customCss]"
    :class="[isPreview ? 'preview-only' : 'no-preview']"
    :sectionSequence="activeElement.value.section_sequence"
    :isDefaultPage="activeElement.value.is_default"
  >
    <template slot="page-header">
      <page-header :getThemeSettings="getThemeSettings">
        <template slot="logo">
          <header-logo
            :isPreview="isPreview"
            :logoPath="membershipMasterData.logo"
            :logoSize="membershipMasterData.logo_size"
            :altText="'Header Logo'"
            @upload-logo="updateLogo"
          ></header-logo>
        </template>
        <template slot="menus">
          <menu-items
            :isPreview="isPreview"
            :position="'header'"
            :activeMenus="activeHeaderMenu"
            :sendToPath="sendToPath"
          ></menu-items>
        </template>
        <template slot="profile" v-if="user && isLoggedIn">
          <header-profile
            :class="[!isPreview ? 'pointer-events-none' : 'cursor-pointer']"
            :user="user"
            :isPreview="isPreview"
            :openProfilePopup="openProfilePopup"
            :logoutUser="logoutUser"
            :isPortal="isPortal"
            :backPortalPage="backPortalPage"
            :profileLabel="membershipMasterData.gen_settings && JSON.parse(membershipMasterData.gen_settings).profile_label"
            :logoutLabel="membershipMasterData.gen_settings &&  JSON.parse(membershipMasterData.gen_settings).logout_label"
          ></header-profile>
        </template>
        <template slot="button" v-else>
          <page-button
            :class="[!isPreview ? 'pointer-events-none' : 'cursor-pointer']"
            :buttonText="'Log In'"
            :buttonCallback="sendToPath"
            :callbackParam="{
              name: 'login',
              params: false,
            }"
            :specialHover="1"
            :getThemeSettings="getThemeSettings"
          ></page-button>
        </template>
      </page-header>
    </template>

    <template slot="page-banner">
      <page-banner
        :overlayColor="activeElement.value.configuration_options.overlay_color"
        :showBanner="activeElement.value.show_banner"
        :bannerType="3"
      >
        <template slot="avatar">
          <banner-avatar
            :isPreview="isPreview"
            :calledFrom="`welcome`"
            :featuredImage="activeElement.value.featured_image"
            :featuredVideoEmbed="activeElement.value.featured_video"
            :overlayColor="
              activeElement.value.configuration_options.overlay_color
            "
            :updateFeaturedImage="updateBannerFeaturedImage"
            :updateFeaturedVideo="updateBannerFeaturedVideo"
            :updateOverlay="updateBannerOverlayColor"
            :updateType="updateBannerType"
            :bannerSettings="activeElement.value.configuration_options"
          ></banner-avatar>
        </template>
        <template slot="story">
          <banner-story>
            <template slot="title">
              <banner-title
                :text="activeElement.value.title_markup"
                :updateTitle="updateBannerTitle"
                :isPreview="isPreview"
              >
              </banner-title>
            </template>
            <template slot="description">
              <banner-description
                :text="activeElement.value.description_markup"
                :updateDescription="updateBannerDescription"
                :isPreview="isPreview"
              ></banner-description>
            </template>
          </banner-story>
        </template>
      </page-banner>
    </template>

    <template slot="breadcrumb">
        <breadcrumb-page :activeElement="activeElement"></breadcrumb-page>
    </template>
    <!-- Dummy Courses Start -->
    <template slot="dummy-courses-1">
      <membership-courses
        class="membership-layout-container"
        v-if="!isPreview && isLoggedIn && activeElement.value.is_default"
        :tileView="tileView"
        :getThemeSettings="getThemeSettings"
      >
        <template slot="title">
          <div v-if="isLoggedIn">
            <div class="body-heading-color" v-if="!isPreview">
              <quill-editor
                v-model="myCoursesLabel"
                :options="getQuillEditorOptions('section-heading')"
              >
              </quill-editor>
            </div>
            <div
              class="body-heading-color"
              v-else
              v-html="myCoursesLabel"
            ></div>
          </div>
          <div v-else>
            <div class="body-heading-color" v-if="!isPreview">
              <quill-editor
                v-model="allCoursesLabel"
                :options="getQuillEditorOptions('section-heading')"
              >
              </quill-editor>
            </div>
            <div
              class="body-heading-color"
              v-else
              v-html="allCoursesLabel"
            ></div>
          </div>
        </template>
        <template slot="tile-view-icons">
          <tile-view-icons
            v-if="!isPreview && isLoggedIn"
            :tileView="tileView"
            :changeTileView="
              ($event) => {
                tileView = $event;
              }
            "
          ></tile-view-icons>
        </template>
        <template slot="courses-list">
          <div class="flex flex-wrap w-full">
            <courses-tile
              v-for="index of dummyCourses"
              :key="index"
              :cover="'https://images.unsplash.com/photo-1541746972996-4e0b0f43e02a?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80'"
              :tileView="tileView"
              :title="`Purchased Course ${index}`"
              :hoverTitle="'Example Only'"
              :description="'This is my membership page'"
              :getThemeSettings="getThemeSettings"
              :class="'full-tile-hover'"
            >
              <template slot="button">
                <page-button
                  :class="[tileView === 'grid' ? 'w-full' : 'w-auto']"
                  :buttonText="
                    isLoggedIn
                      ? getGenSettings.after_login_label
                      : getGenSettings.before_login_label    
                  "
                  :buttonCallback="() => {}"
                  :callbackParam="''"
                  :specialHover="0"
                  :getThemeSettings="getThemeSettings"
                ></page-button>
              </template>
            </courses-tile>
          </div>
        </template>
      </membership-courses>
    </template>

    <template slot="dummy-courses-2">
      <membership-courses
        class="membership-layout-container"
        v-if="!isPreview && activeElement.value.is_default"
        :tileView="tileView"
        :getThemeSettings="getThemeSettings"
      >
        <template slot="title">
          <div v-if="isLoggedIn">
            <div class="body-heading-color" v-if="!isPreview">
              <quill-editor
                v-model="otherCoursesLabel"
                :options="getQuillEditorOptions('section-heading')"
              >
              </quill-editor>
            </div>
            <div
              class="body-heading-color"
              v-else
              v-html="otherCoursesLabel"
            ></div>
          </div>
          <div v-else>
            <div class="body-heading-color" v-if="!isPreview">
              <quill-editor
                v-model="allCoursesLabel"
                :options="getQuillEditorOptions('section-heading')"
              >
              </quill-editor>
            </div>
            <div
              class="body-heading-color"
              v-else
              v-html="allCoursesLabel"
            ></div>
          </div>
        </template>
        <template slot="tile-view-icons">
          <tile-view-icons
            v-if="!isPreview && isLoggedIn"
            :tileView="tileView"
            :changeTileView="
              ($event) => {
                tileView = $event;
              }
            "
          ></tile-view-icons>
        </template>
        <template slot="courses-list">
          <div v-if="!isLoggedIn" class="flex flex-wrap w-full">
            <!-- 6 tiles -->
            <courses-tile
              v-for="index of dummyCourses2"
              :key="index"
              :cover="'https://images.unsplash.com/photo-1541746972996-4e0b0f43e02a?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80'"
              :tileView="tileView"
              :title="`Buy Course ${index}`"
              :hoverTitle="'Example Only'"
              :description="'This is my membership page'"
              :getThemeSettings="getThemeSettings"
              :class="'full-tile-hover'"
            >
              <template slot="button">
                <page-button
                  :class="[tileView === 'grid' ? 'w-full' : 'w-auto']"
                  :buttonText="getGenSettings.before_login_label"
                  :buttonCallback="() => {}"
                  :callbackParam="''"
                  :specialHover="0"
                  :getThemeSettings="getThemeSettings"
                ></page-button>
              </template>
            </courses-tile>
          </div>
          <div v-else class="flex flex-wrap w-full">
            <!-- 3 tiles -->
            <courses-tile
              v-for="index of dummyCourses"
              :key="index"
              :cover="'https://images.unsplash.com/photo-1541746972996-4e0b0f43e02a?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80'"
              :tileView="tileView"
              :title="`Buy Course ${index}`"
              :hoverTitle="'Example Only'"
              :description="'This is my membership page'"
              :getThemeSettings="getThemeSettings"
              :class="'full-tile-hover'"
            >
              <template slot="button">
                <page-button
                  :class="[tileView === 'grid' ? 'w-full' : 'w-auto']"
                  :buttonText="getGenSettings.before_login_label"
                  :buttonCallback="() => {}"
                  :callbackParam="''"
                  :specialHover="0"
                  :getThemeSettings="getThemeSettings"
                ></page-button>
              </template>
            </courses-tile>
          </div>
        </template>
      </membership-courses>
    </template>
    <!-- Dummy Courses End -->

    <!-- Non Dummy Courses Start  -->
    <template slot="my-courses">
      <membership-courses
        class="membership-layout-container"
        v-if="
          isPreview && activeElement.value.is_default && myCourses.length > 0
        "
        :tileView="tileView"
        :getThemeSettings="getThemeSettings"
      >
        <template slot="title">
          <div class="body-heading-color" v-if="!isPreview">
            <quill-editor
              v-model="myCoursesLabel"
              :options="getQuillEditorOptions('section-heading')"
            >
            </quill-editor>
          </div>
          <div
            class="body-heading-color"
            v-else
            v-html="user && user.id !== -1 ? myCoursesLabel : allCoursesLabel"
          ></div>
        </template>
        <template slot="tile-view-icons">
          <tile-view-icons
            v-if="!isPreview && isLoggedIn"
            :tileView="tileView"
            :changeTileView="
              ($event) => {
                tileView = $event;
              }
            "
          ></tile-view-icons>
        </template>
        <template slot="courses-list">
          <courses-tile
            v-for="(course, index) in membershipMasterData.courses.filter(
              (course) => !course.is_locked
            )"
            :key="index"
            :cover="course.featured_image"
            :tileView="tileView"
            :title="course.title"
            :hoverTitle="course.title"
            :description="course.description"
            :getThemeSettings="getThemeSettings"
          >
            <template slot="button">
              <page-button
                :class="[tileView === 'grid' ? 'w-full' : 'w-auto']"
                :buttonText="
                  user && user.id !== -1
                    ? getGenSettings.after_login_label
                    : getGenSettings.before_login_label
                "
                :buttonCallback="
                  user && user.id !== -1 ? sendToPath : redirectToPath
                "
                :callbackParam="
                  user && user.id !== -1
                    ? {
                        name: `course`,
                        params: { slug: course.slug },
                      }
                    : course.sales_url
                "
                :specialHover="0"
                :getThemeSettings="getThemeSettings"
              ></page-button>
            </template>
          </courses-tile>
        </template>
      </membership-courses>
    </template>

    <template slot="other-courses">
      <membership-courses
        class="membership-layout-container"
        v-if="
          isPreview &&
          activeElement.value.is_default &&
          otherCourses.length > 0 &&
          membershipMasterData.course_display == 1
        "
        :tileView="tileView"
        :getThemeSettings="getThemeSettings"
      >
        <template slot="title">
          <div class="body-heading-color" v-if="!isPreview">
            <quill-editor
              v-model="otherCoursesLabel"
              :options="getQuillEditorOptions('section-heading')"
            >
            </quill-editor>
          </div>
          <div
            class="body-heading-color"
            v-else
            v-html="otherCoursesLabel"
          ></div>
        </template>
        <template slot="tile-view-icons">
          <tile-view-icons
            v-if="!isPreview && isLoggedIn"
            :tileView="tileView"
            :changeTileView="
              ($event) => {
                tileView = $event;
              }
            "
          ></tile-view-icons>
        </template>
        <template slot="courses-list">
          <courses-tile
            v-for="(course, index) in otherCourses"
            :key="index"
            :cover="course.featured_image"
            :tileView="tileView"
            :title="course.title"
            :hoverTitle="course.title"
            :description="course.description"
            :getThemeSettings="getThemeSettings"
          >
            <template slot="button">
              <page-button
                :class="[tileView === 'grid' ? 'w-full' : 'w-auto']"
                :buttonText="getGenSettings.before_login_label"
                :buttonCallback="redirectToPath"
                :callbackParam="course.sales_url"
                :specialHover="0"
                :getThemeSettings="getThemeSettings"
              ></page-button>
            </template>
          </courses-tile>
        </template>
      </membership-courses>
    </template>
    <!-- Non Dummy Courses End -->

    <template slot="page-canvas">
      <page-canvas
        class="membership-layout-container"
        :isPreview="isPreview"
        :files="files"
        :getThemeSettings="getThemeSettings"
        :getSections="getSections"
        :addNewSection="addNewSection"
        :deleteSection="deleteSection"
        :moveSection="moveSection"
        :cloneSection="cloneSection"
        :updateSectionTitle="updateSectionTitle"
        :updateSectionContent="updateSectionContent"
      ></page-canvas>
    </template>

    <template slot="page-footer">
      <page-footer :getThemeSettings="getThemeSettings">
        <template slot="logo">
          <footer-logo
            :isPreview="isPreview"
            :logoPath="membershipMasterData.footer_logo"
            :altText="'Footer Logo'"
            :logoSize="membershipMasterData.footer_logo_size"
            @upload-logo="updateLogo"
          ></footer-logo>
        </template>
        <template slot="menus">
          <menu-items
            :isPreview="isPreview"
            :position="'footer'"
            :activeMenus="activeFooterMenu"
            :sendToPath="sendToPath"
          ></menu-items>
        </template>
      </page-footer>
    </template>
  </page-markup>
</template>
<script>
import PageMarkup from './page-markup';

import PageHeader from '../../common/header/header';
import HeaderLogo from '../../common/header/logo';
import HeaderProfile from '../../common/header/profile';

import PageBanner from '../../common/banner/banner';
import BannerAvatar from '../../common/banner/avatar/avatar';
import BannerStory from '../../common/banner/story/story';
import BannerTitle from '../../common/banner/story/title';
import BannerDescription from '../../common/banner/story/description';

import TileViewIcons from '../../common/courses/tile-view-icons';
import MembershipCourses from '../../common/courses/courses';
import CoursesTile from '../../common/courses/tile';

import PageFooter from '../../common/footer/footer';
import FooterLogo from '../../common/footer/logo';

import PageCanvas from '../../common/canvas/canvas';

import PageButton from '../../common/button';
import MenuItems from '../../common/menuItems';
import quillMixin from '../../mixins/quill';
import BreadcrumbPage from '../../common/breadcrumbPages';

// import { mapActions } from 'vuex';
export default {
  name: 'PageTemplate',
  mixins: [quillMixin],
  components: {
    PageMarkup,
    PageHeader,
    HeaderLogo,
    HeaderProfile,
    PageBanner,
    BannerAvatar,
    BannerStory,
    BannerTitle,
    BannerDescription,
    MembershipCourses,
    TileViewIcons,
    CoursesTile,
    PageFooter,
    FooterLogo,
    PageCanvas,
    PageButton,
    MenuItems,
    BreadcrumbPage
  },
  data() {
    return {
      dummyCourses2: [1, 2, 3, 4, 5, 6],
      dummyCourses: [1, 2, 3],
    };
  },
  props: {
    isPreview: {
      type: Boolean,
      default: true,
    },
    user: {
      type: Object,
      default: () => {
        return { id: -1, name: 'John' };
      },
    },
    openProfilePopup: {
      type: Function,
      default: () => {},
    },
    logoutUser: {
      type: Function,
      default: () => {},
    },
    sendToPath: {
      type: Function,
      default: () => {},
    },
    redirectToPath: {
      type: Function,
      default: () => {},
    },
    files: {},
    activeElement: {},
    activeHeaderMenu: {},
    activeFooterMenu: {},
    membershipMasterData: {},
    updateBannerTitle: {},
    updateBannerDescription: {},
    updateBannerFeaturedImage: {},
    updateBannerFeaturedVideo: {},
    updateBannerOverlayColor: {},
    updateBannerType: {},
    updatetileView: {
      type: Function,
      default: () => {},
    },
    updateMyCoursesLabel: {
      type: Function,
      default: () => {},
    },
    updateOtherCoursesLabel: {
      type: Function,
      default: () => {},
    },
    updateAllCoursesLabel: {
      type: Function,
      default: () => {},
    },
    getThemeSettings: {},
    addNewSection: {},
    deleteSection: {},
    moveSection: {},
    cloneSection: {},
    updateSectionTitle: {},
    updateSectionContent: {},
    updateMembershipMastetData: {},
    isLoggedIn: {
      type: Boolean,
      default: true,
    },
    isPortal: {
      type: Boolean,
      default: false,
    },
    backPortalPage: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    getGenSettings(){
        return JSON.parse(this.membershipMasterData.gen_settings)
    },
    customCss() {
      return {
        '--template-body-bg-color': this.themeSettings.body_section.bg_color,
        '--template-body-heading-color': this.themeSettings.body_section
          .body_heading_color,
      };
    },
    getSections() {
      return () => {
        return this.activeElement.value.sections;
      };
    },
    myCoursesLabel: {
      get() {
        return (
          this.activeElement.value.configuration_options.my_courses_label ||
          'My Courses'
        );
      },
      set(value) {
        this.updateMyCoursesLabel(value);
      },
    },
    otherCoursesLabel: {
      get() {
        return (
          this.activeElement.value.configuration_options.other_courses_label ||
          'Other Courses'
        );
      },
      set(value) {
        this.updateOtherCoursesLabel(value);
      },
    },
    allCoursesLabel: {
      get() {
        return (
          this.activeElement.value.configuration_options.all_courses_label ||
          'All Courses'
        );
      },
      set(value) {
        this.updateAllCoursesLabel(value);
      },
    },
    myCourses() {
      return this.membershipMasterData.courses.filter(
        (course) => !course.is_locked
      );
    },
    otherCourses() {
      return this.membershipMasterData.courses.filter(
        (course) => course.is_locked
      );
    },
    themeSettings() {
      return this.getThemeSettings();
    },
    tileView: {
      get() {
        if (
          this.activeElement.value.configuration_options.hasOwnProperty(
            'tile_view'
          )
        ) {
          return this.activeElement.value.configuration_options.tile_view;
        }

        return 'grid';
      },
      set(value) {
        this.updatetileView(value);
      },
    },
  },
  methods: {
    // ...mapActions('membershipBuilder', ['updateMembershipMastetData']),
    updateLogo(payload) {
      payload.id = this.$route.params.id;
      const updateMembershipData = Object.assign(
        {},
        this.membershipMasterData,
        payload
      );
      this.updateMembershipMastetData(updateMembershipData);
    },
  },
};
</script>
<style lang="scss" scoped>
.body-bg-color {
  background-color: var(--template-body-bg-color);
}
.body-heading-color {
  color: var(--template-body-heading-color);
}
</style>
<style lang="scss">
@import '../../../../assets/css/campton_font.css';
.membership-layout-container {
  max-width: 950px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 15px;
  padding-right: 15px;
}
.btn-radius {
  border-radius: 6px !important;
}
.full-tile-hover {
  .tile-wrapper {
    position: relative;
    .relative {
      position: relative;
    }
  }
}
.sticky-edit-icon {
  top: 12px;
  left: 38%;
  z-index: 12;
}
@media only screen and (min-width: 3200px) {
  .big-screen {
    height: 100vh;
  }
}
.preview-only {
  .tile-wrapper {
    .static {
      position: relative;
    }
  }
}
</style>
